import React from 'react';

const Jurisprudencia = () => {
    return (
        <div className='container-calculo'>
            <div className='label-calculo'>
                <h1 className='titulo-calculo'>Aluguel</h1>
            </div>
        </div>
    );
};

export default Jurisprudencia;